<mat-form-field style="width: 100%">
    <mat-label>Verkaufspreis</mat-label>
    <mat-select
        placeholder="Verkaufspreis"
        [compareWith]="comparator"
        (selectionChange)="verkaufspreisChanged($event)"
        [formControl]="vkCtrl"
        [attr.data-cy]="'cvsvs_mat-select_1'"
    >
        <mat-option *ngIf="allowEmptySelection" [attr.data-cy]="'cvsvs_mat-option_1_5'">Keine</mat-option>
        <mat-option
            *ngFor="let v of verkaufspreise; let i = index"
            [value]="v"
            [attr.data-cy]="'cvsvs_mat-option_2_5_' + i"
            >{{ v.bezeichnung }}</mat-option
        >
    </mat-select>
</mat-form-field>
